import React, { useState } from 'react';
import {
  getCurrentWeekNumber,
  getDateOfWeek,
  weeksInYear,
} from '../utils/week';
import useLocalisation from './useLocalisation';
import * as classes from './useCalendar.module.css';

function useCalendar() {
  const DAY = 86400000;
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const currentWeek = getCurrentWeekNumber();
  const [weeks] = useState(() => {
    let missingWeeks = 0
    const length = weeksInYear(today.getFullYear());
    const wks = [];
    for (let i = 0; i < length; i++) {
      wks.push({
        number: i + 1,
        disabled: i + 1 < currentWeek,
        year: today.getFullYear(),
      });
      if(i + 1 < currentWeek){
        missingWeeks ++
      }
    }

    if (missingWeeks > 0){
      for (let i = 0; i < missingWeeks; i++) {
        wks.push({
          number: i + 1,
          disabled: false,
          year: today.getFullYear()+1,
        });
      }
    }
    return wks;
  });

  const [selectedDay, setSelectedDay] = useState(null);

  const [week, setWeek] = useState(() => {
    const firstActive = weeks.find((w) => !w.disabled);
    if (firstActive) {
      const start = getDateOfWeek(firstActive.number, today.getFullYear());
      const w = [
        {
          date: start,
          selected: false,
          disabled: start.getTime() < today.getTime(),
        },
      ];
      for (let i = 0; i < 6; i++) {
        const date = new Date(start.getTime() + DAY * (1 + i));
        w.push({
          date,
          //Should be disabled if smaller than today, or no available bookings
          disabled: date.getTime() < today.getTime(),
          selected: false,
        });
      }
      return w;
    }
    return [];
  });
  const [selectedWeek, setSelectedWeek] = useState(currentWeek);

  const handleWeekSelect = (evt) => {
    const selectedWk = weeks.find((w)=>(w.number === parseInt(evt.target.value) && !w.disabled));
    setSelectedWeek(selectedWk.number);
    setSelectedDay(null);

    const start = getDateOfWeek(selectedWk.number, selectedWk.year);
    const w = [
      {
        date: start,
        selected: false,
        disabled: start.getTime() < today.getTime(),
      },
    ];
    for (let i = 0; i < 6; i++) {
      const date = new Date(start.getTime() + DAY * (1 + i));
      w.push({
        date,
        //Should be disabled if smaller than today, or no available bookings
        disabled: date.getTime() < today.getTime(),
        selected: false,
      });
    }
    setWeek(w);
  };

  const WeekSelector = ({ language = 'fi' }) => {
    const { localize } = useLocalisation(language);
    return (
      !!weeks.length && (
        <div className={classes.select}>
          <select onChange={handleWeekSelect} value={selectedWeek}>
              <optgroup label={today.getFullYear()}>
              {weeks
                .filter((w) => w && !w.disabled && w.year === today.getFullYear())
                .map((w) => (
                  <option key={w.number} value={w.number}>
                      {localize('WEEK')} {w.number}
                  </option>
                ))}
              </optgroup>
              {weeks.find((w)=> w.year === today.getFullYear()+1)&& (
                <optgroup label={today.getFullYear() + 1}>
                {weeks
                  .filter((w) => w && !w.disabled && w.year === today.getFullYear()+1)
                  .map((w) => (
                    <option key={w.number} value={w.number}>
                        {localize('WEEK')} {w.number}
                    </option>
                  ))}
                </optgroup>
              )}
          </select>
        </div>
      )
    );
  };

  return {
    weeks,
    week,
    setWeek,
    selectedWeek,
    selectedDay,
    setSelectedDay,
    WeekSelector,
  };
}

export default useCalendar;
